import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Fades the routed page in on every path change without remounting it.
// Opacity only: a transform would make the wrapper the containing block for
// position:fixed children (toasts, FABs) and shift them mid-animation.
export default function useRouteFade() {
  const ref = useRef(null);
  const { pathname } = useLocation();
  useEffect(() => {
    const el = ref.current;
    if (!el?.animate) return;
    if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;
    el.animate([{ opacity: 0 }, { opacity: 1 }], { duration: 180, easing: "ease-out" });
  }, [pathname]);
  return ref;
}
